import { useRouter } from 'next/router';
import { Props } from '../ListingCard.types';
import { removeEverythingAfterHash } from 'shared/helpers';

type UseRedirectWithSearchIndentifier = (
    props: Pick<Props, 'listingUris' | 'searchIdentifier' | 'listingId'>
) => () => void;

export const useRedirectWithSearchIndentifier: UseRedirectWithSearchIndentifier = ({
    listingUris,
    searchIdentifier,
    listingId
}) => {
    const { push, replace, asPath } = useRouter();

    return () => {
        const searchIdentifierQueryString = searchIdentifier
            ? `?search_identifier=${searchIdentifier}`
            : '';

        const detailsLink = listingUris?.detail
            ? `${listingUris?.detail}${searchIdentifierQueryString}`
            : '#';

        const pathWithoutAnchor = removeEverythingAfterHash(asPath);
        const newHistoryPath = `${pathWithoutAnchor}#listing_${listingId}`;

        replace(newHistoryPath);
        push(detailsLink);
    };
};
